// extracted by mini-css-extract-plugin
module.exports = {"container":"ServerError_container__JSniF","title":"ServerError_title__f_fcK","backBtnStyles":"ServerError_backBtnStyles__XmdSl"};